// src/hooks/useActivities.js
import { useQuery } from "react-query";
import { ACTIVITIES } from "../config/apiConfig";
import axiosInstance from "../config/axiosInstance";

/**
 * Parâmetros aceitos:
 * {
 *   mode: "global" | "card",
 *   cardId?: number,
 *   page: number,
 *   itemsPerPage: number,
 *   q?: string,
 *   actions?: string,        // CSV
 *   actorUserId?: string|number,
 *   targetType?: string,
 *   targetId?: string|number,
 *   dateFrom?: string,       // YYYY-MM-DD
 *   dateTo?: string          // YYYY-MM-DD
 * }
 */
export function useActivities(params) {
  const {
    mode = "global",
    cardId,
    page = 1,
    itemsPerPage = 30,
    q,
    actions,
    actorUserId,
    targetType,
    targetId,
    dateFrom,
    dateTo,
  } = params || {};

  const endpoint =
    mode === "card"
      ? cardId
        ? ACTIVITIES.LIST_BY_CARD(cardId)
        : null
      : ACTIVITIES.LIST_GLOBAL;

  return useQuery({
    queryKey: [
      "activities",
      mode,
      cardId ?? null,
      {
        page,
        itemsPerPage,
        q,
        actions,
        actorUserId,
        targetType,
        targetId,
        dateFrom,
        dateTo,
      },
    ],
    queryFn: async () => {
      if (!endpoint) return { data: [], totalPages: 1, totalCount: 0 };
      const res = await axiosInstance.get(endpoint, {
        params: {
          page,
          itemsPerPage,
          ...(q ? { q } : {}),
          ...(actions ? { actions } : {}),
          ...(actorUserId ? { actorUserId } : {}),
          ...(targetType ? { targetType } : {}),
          ...(targetId ? { targetId } : {}),
          ...(dateFrom ? { dateFrom } : {}),
          ...(dateTo ? { dateTo } : {}),
        },
      });
      return res.data;
    },
    enabled: Boolean(endpoint), // só executa se houver endpoint válido
    keepPreviousData: true, // paginação suave
    staleTime: 30 * 1000, // 30s
  });
}
